import BarChartIcon from '@mui/icons-material/BarChart';
import UnitDetailsIconButton from "./UnitDetailsIconButton";

export interface StorageUnitsButtonProps {
  active: boolean;
  onClick: () => void;
}

export default function StorageUnitsButton(props: StorageUnitsButtonProps) {
  return (
    <UnitDetailsIconButton
      active={props.active}
      onClick={props.onClick}
      tooltip="Details"
    >
      <BarChartIcon sx={{ height: 24, width: 24 }} />
    </UnitDetailsIconButton>
  );
}
